/** A thin decorator over JSON.stringify that has some common sense defaults with a space of 2
 * @param value A JavaScript value, usually an object or array, to be converted.
 * @param space Adds indentation, white space, and line break characters to the return-value JSON text to make it easier to read.
 * @param replacer An array of strings and numbers that acts as an approved list for selecting the object properties that will be stringified.
 */
const stringifyObj = (
    value: unknown,
    space: string | number = 2,
    replacer: (number | string)[] | null = null
) => JSON.stringify(value, replacer, space);

export { stringifyObj };
